import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataBrakes } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeBrakesAccordionProps {
  brakesData?: EquipmentModelLatestFipeDataBrakes
}

export default function FipeBrakesAccordion({ brakesData }: FipeBrakesAccordionProps) {
  return (
    <Accordion
      name="Brakes"
      head="Freios"
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Dianteiros" 
            value={brakesData?.Dianteiros} 
          />
          <InfoField 
            label="Traseiros" 
            value={brakesData?.Traseiros} 
          />
          <InfoField 
            label="Frenagem 100 a 0" 
            value={brakesData?.Frenagem100a0} 
          />
        </div>
      }
    />
  )
}